import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import React from "react";
import {
    AVAILS_PLUS_AIRTABLE_SOURCES,
    AvailsPlusAirtableSourceKey,
    DEFAULT_AVAILS_PLUS_AIRTABLE_SOURCE,
    isAvailsPlusAirtableSourceKey,
} from "./availsPlusAirtableSources";

interface AirtableSourceSelectProps {
    value: AvailsPlusAirtableSourceKey;
    onChange: (value: AvailsPlusAirtableSourceKey) => void;
    fullWidth?: boolean;
    size?: "small" | "medium";
    sx?: object;
}

const AirtableSourceSelect = ({
    value,
    onChange,
    fullWidth = false,
    size = "small",
    sx,
}: AirtableSourceSelectProps) => {
    const baseId = React.useId();
    const labelId = `${baseId}-label`;

    // Hide selector when the test workspace is disabled (only SVOD remains).
    if (AVAILS_PLUS_AIRTABLE_SOURCES.length <= 1) {
        return null;
    }

    const selectedValue = isAvailsPlusAirtableSourceKey(value)
        ? value
        : DEFAULT_AVAILS_PLUS_AIRTABLE_SOURCE;

    const handleChange = (
        event: SelectChangeEvent<AvailsPlusAirtableSourceKey>
    ) => {
        onChange(event.target.value as AvailsPlusAirtableSourceKey);
    };

    return (
        <FormControl fullWidth={fullWidth} size={size} sx={sx}>
            <InputLabel id={labelId}>Airtable</InputLabel>
            <Select
                labelId={labelId}
                label="Airtable"
                value={selectedValue}
                onChange={handleChange}
            >
                {AVAILS_PLUS_AIRTABLE_SOURCES.map((source) => (
                    <MenuItem key={source.key} value={source.key}>
                        {source.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default AirtableSourceSelect;
